/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/**
 * Defines the Design Language System (DLS) Material Ignition Icon component.
 */
export const MaterialIgnitionIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M22 17.9V21.9H18V18.9H15V15.9H12L9.7 13.7C9.1 13.9 8.6 14 8 14C4.7 14 2 11.3 2 8C2 4.7 4.7 2 8 2C11.3 2 14 4.7 14 8C14 8.6 13.9 9.2 13.7 9.7L22 17.9ZM7 4.89999C5.9 4.89999 5 5.79999 5 6.89999C5 7.99999 5.9 8.89999 7 8.89999C8.1 8.89999 9 7.99999 9 6.89999C9 5.79999 8.1 4.89999 7 4.89999Z' fill={iconColor} />
    </svg>
  );
};

export default MaterialIgnitionIcon;
